module.exports = __webpack_public_path__ + "static/media/Carrito.62430a54.svg";